// The enums of the port of crm (ADR-292), plain tuples: @nexxt/db builds the types of the projection from them
// (ADR-271).

/** A customer that has not bought yet, or one that has (ADR-289). */
export const accountStages = ["prospect", "customer"] as const;
export type AccountStage = (typeof accountStages)[number];
